import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Read environment variables
const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const appId = process.env.REACT_APP_FIREBASE_APP_ID;
const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

// Check if required environment variables are set
if (!apiKey || !authDomain || !projectId || !storageBucket || !messagingSenderId || !appId) {
    console.error('Missing Firebase environment variables. Ensure REACT_APP_FIREBASE_... variables are set in your .env file.');
    // You might want to throw an error here in production environments
    // throw new Error('Firebase configuration is missing.');
}

// Construct config object ONLY from environment variables
const firebaseConfig = {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId // measurementId is optional, so no check needed
};

// Log the API key being used (safer logging)
//console.log('Using Firebase config from env vars with API key starting with:', 
  //firebaseConfig.apiKey ? firebaseConfig.apiKey.substring(0, 8) + '...' : 'undefined');
//console.log('Using storage bucket:', firebaseConfig.storageBucket);

// Initialize Firebase (prevent re-initialization)
let app;
if (!getApps().length) {
    try {
        app = initializeApp(firebaseConfig);
        //console.log('Firebase initialized successfully');
    } catch (error) {
        console.error('Error initializing Firebase:', error);
        // Consider how to handle initialization errors gracefully
        throw error; 
    }
} else {
    app = getApp(); // Get existing app instance
    //console.log('Using existing Firebase app instance.');
}

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Use auth emulator in development if needed
// if (process.env.NODE_ENV === 'development') {
//   connectAuthEmulator(auth, 'http://localhost:9099');
// }

// Initialize Storage - REMOVE the hardcoded bucket URL
// Let it use the storageBucket from firebaseConfig
export const storage = getStorage(app);

export default app; 